import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import UsersList from '@/view/users/UsersList';

export default {
  list: UsersList,
  icon: AdminPanelSettingsIcon,
};
